// TK-15 — the list itself: add a task, Three for today, the rest, the pool.
// Rendered by the float and by the popped-out window, so both read the same.
import React from 'react';
import { fmtMinutes } from '../../utils/taskLists';
import TaskDialog from './TaskDialog';
import { announceTasks } from './useTaskList';

export const TaskListBody = ({ list, prefix, onGo, goLabel = 'Tasks page →' }) => {
  const row = (t) => {
    const done = t.status === 'completed';
    const subs = Array.isArray(t.subtasks) ? t.subtasks : [];
    return (
      <div key={t.id} className={`kmt-row kmt-row--float${done ? ' is-done' : ''}`} data-testid={`${prefix}-row-${t.id}`}>
        <button type="button" className={`kmt-cb${done ? ' is-on' : ''}`} aria-label="Done"
          onClick={() => list.toggle(t)} data-testid={`${prefix}-tick-${t.id}`} />
        <div className="kmt-body">
          <button type="button" className="kmt-ttl" onClick={() => list.setDialog({ task: t })}
            data-testid={`${prefix}-title-${t.id}`}>{t.title}</button>
          {subs.length > 0 && (
            <button type="button" className="kmt-sub kmt-float__steps-toggle"
              onClick={() => list.setOpenSteps(p => ({ ...p, [t.id]: !p[t.id] }))}
              data-testid={`${prefix}-steps-${t.id}`}>
              {list.openSteps[t.id] ? '▾' : '▸'} {subs.filter(s => s.completed).length}/{subs.length} steps
            </button>
          )}
          {list.openSteps[t.id] && subs.map(s => (
            <div key={s.id} className="kmt-dlg__step">
              <button type="button" className={`kmt-cb${s.completed ? ' is-on' : ''}`} aria-label="Done"
                onClick={() => list.stepToggle(t, s)} data-testid={`${prefix}-step-${t.id}-${s.id}`} />
              <span className={s.completed ? 'is-done' : ''}>{s.title}</span>
            </div>
          ))}
        </div>
        <span className="kmt-r">{t.estimate_minutes ? fmtMinutes(t.estimate_minutes) : ''}</span>
      </div>
    );
  };

  return (
    <>
      <div className="kmt-capture kmt-float__cap" data-testid={`${prefix}-capture`}>
        <span className="kmt-capture__plus">+</span>
        <input value={list.text} onChange={e => list.setText(e.target.value)} disabled={list.busy}
          onKeyDown={e => { if (e.key === 'Enter') list.capture(); }}
          placeholder="Add a task…" data-testid={`${prefix}-capture-input`} />
        <button type="button" className="kmt-capture__hint" onClick={() => list.setDialog({ task: null })}
          data-testid={`${prefix}-more`}>more…</button>
      </div>
      <div className="kmt-float__body" data-testid={`${prefix}-body`}>
        <span className="kmt-float__lab">Three for today</span>
        {list.three.length === 0 && <p className="kmt-empty">Pin up to three on the Tasks page.</p>}
        {list.three.map(row)}
        <span className="kmt-float__lab">The rest · {list.rest.length}</span>
        {list.rest.map(row)}
        {list.restDone.map(row)}
      </div>
      <footer className="kmt-float__ft">
        <span className="kmt-float__lab">Pool · Inbox {list.inbox} · Due soon {list.dueSoon}</span>
        <button type="button" className="kmt-float__go" onClick={onGo}
          data-testid={`${prefix}-page`}>{goLabel}</button>
      </footer>
    </>
  );
};

// The sheet is a window of its own: it is rendered OUTSIDE the float's box,
// which clips what it holds.
export const TaskSheet = ({ list }) => (list.dialog ? (
  <TaskDialog open task={list.dialog.task} projects={list.projects} me={list.me}
    users={list.users} contacts={list.contacts}
    onClose={() => list.setDialog(null)}
    onSaved={() => { list.setDialog(null); list.load(); announceTasks(); }} />
) : null);

export default TaskListBody;
